<!--
 * @Author: zjg
 * @Date: 2020-04-14 15:14:32
 * @LastEditTime: 2020-04-29 17:34:20
 * @Deccription: 所有异常的容器组件
 -->
<template>
  <div class="back" ref="abnormalContainer">
    <ul
      ref="content"
      class="ab-content"
      :style="{marginLeft: left + 'px',marginTop: top + 'px'}"
    >
      <!-- 图标 -->
      <li
        class="ab-icon-wrapper"
        :style="{marginTop:list[type].iconMarginTop+'px'}"
      >
        <span
          class="ab-img"
          :style="{paddingRight:list[type].pright}"
        >
          <svg
            class="ab-svg"
            :style="{width: list[type].iconWH + 'px', height: list[type].iconWH + 'px'}"
          >
            <use :xlink:href="list[type].iconId" />
          </svg>
        </span>
      </li>
      <!-- 异常情况描述 -->
      <li
        class="ab-tip-wrapper"
        :style="{textAlign:list[type].algin}"
      >
        <div class="ab-title">
          <span
            :style="{color: list[type].color,fontSize:list[type].fontSize+'px'}"
            v-html="list[type].title"
          />
          <span
            v-show="list[type].isVirus"
            class="virus"
          >{{ $t('病毒') }}</span>
        </div>
        <span
          class="ab-size"
          v-html="list[type].size"
        />
        <span
          class="ab-reason"
          :style="{color: list[type].color}"
        >{{ $t(list[type].reason) }}</span>
        <span
          class="ab-description"
          v-html="list[type].description"
        />
      </li>
      <!-- 按钮 -->
      <li
        v-if="!list[type].link"
        class="ab-btn-wrapper"
        :style="{marginTop: list[type].marginTop+'px'}"
      >
        <button
          v-for="(btn, i) in list[type].btnText"
          v-show="btn.val"
          :key="i"
          :class="['cp','lv-bn','lv-80','lv-rm-12','lv-bh','lv-ba', 'c-btn']"
          @click="abnormal(btn.key)"
        >
          {{ $t(btn.val) }}
        </button>
      </li>
      <li
        v-else
        class="ab-btn-wrapper"
        :style="{marginTop: list[type].marginTop+'px'}"
      >
        <button
          v-for="(btn, i) in list[type].btnText"
          v-show="btn.val"
          :key="i"
          class="link-download"
          @click="abnormal(btn.key)"
        >
          {{ $t(btn.val) }}
        </button>
      </li>
      <li
        v-show="list[type].link && !isPreviewInLinkFolder"
        class="ab-qrwrapper"
      >
        <slot name="qrcode">
          <div class="qr-wrapper">
            <img
              :src="getCreateCode()"
              alt="erweima"
            ><!--
                        --><div class="right">
                            <span>{{ $t('扫描二维码在手机上查看') }}</span>
                        </div>
          </div>
        </slot>
      </li>
      <li class="copyright" v-if="list[type].copyright">
        <div v-html="list[type].copyright" />
      </li>
    </ul>
  </div>
</template>
<script>
/*
 * @Author: lisiyi
 * @Date: 2019-12-25 16:16
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2019-12-31 18:13:04
 */
import {
  typeIcon, formatBytes, isHasAuth, isClient, resolveFileAction,
} from 'js/util/util'

export default {
  props: {
    type: { // 异常情况类型
      type: String,
      default: 'loadFail',
    },
    data: { // 当前文件的数据
      type: Object,
      default: () => ({}),
    },
    abnormalData: { // 异常页面的data
      type: Object,
      default: () => ({
        maxSize: 0,
      }),
    },
  },
  data() {
    return {
      left: 0, // 定位margin-left
      top: 0, // 定位margin-top
      list: { // 异常情况列表
        delete: { // 文件被删除
          iconId: '#delete', // svg id
          iconWH: 130,
          reason: '该文件已被删除', // 提示内容
          btnText: [{ // 按钮文字
            val: '返回',
            key: 'back',
          }],
        },
        badfile: { // 文件损坏
          iconId: '#badfile',
          iconWH: 130,
          reason: '文件已损坏',
          btnText: [{
            val: '返回',
            key: 'back',
          }],
        },
        notSupport: { // 不支持预览的格式
          iconId: `#${this.getFileIcon()}`,
          iconWH: 60,
          title: `<span>${this.getTitle()}</span><span style="padding-left: 8px;">${this.data.size}</span>`,
          reason: this.getExt() === '' ? this.$t('该类型的文件不支持预览') : `${this.getExt()}${this.$t('类型的文件不支持预览')}`,
          btnText: [{
            val: this.checkPermission() ? '下载' : '',
            key: 'download',
          }],
        },
        noAccess: { // 无权限
          iconId: '#noPower',
          iconWH: 130,
          reason: '没有权限查看该文件',
          btnText: [{
            val: '返回',
            key: 'back',
          }],
        },
        linkNoAccess: { // 外链无权限
          iconId: '#noPower',
          iconWH: 130,
          reason: '没有权限查看该文件',
        },
        lowSecret: { // 低密级
          iconId: '#loadFail',
          iconWH: 130,
          reason: this.$t('受文件密级管控规则限制，无法查看高密级文件'),
        },
        emptyPage: { // 空页面
          iconId: '#loadFail',
          iconWH: 130,
          reason: this.$t('当前用户无法访问该文件，请联系管理员'),
        },
        oversize: { // 超过大小限制
          iconId: `#${this.getFileIcon()}`,
          iconWH: 60,
          title: `<span style="display: inline-block;max-width: 500px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;vertical-align: middle;">${this.getTitle()}</span><span style="padding-left: 8px;">${this.data.size}</span>`,
          reason: this.$t('该文档大小超过{n}，为了提供稳定的预览体验，目前仅支持下载查看', { n: formatBytes(this.abnormalData.maxSize) }),
          btnText: [{
            val: this.checkPermission() ? isClient() ? '本地打开' : '下载' : '',
            key: 'download',
          }],
        },
        loadFail: { // pdfjs获取资源失败，或者后端接口50X
          iconId: '#loadFail',
          iconWH: 130,
          reason: '啊哦，出错了…',
          description: `${this.$t('连接问题或文件损坏会导致预览无法加载')}<br/>${this.$t('5分钟后可再次尝试，或联系系统管理员')}`,
          btnText: [{
            val: '刷新重试',
            key: 'refresh',
          }, {
            val: this.checkPermission() ? isClient() ? '本地打开' : '下载查看' : '',
            key: 'download',
          }],
        },
        invalid: { // 链接未生效
          iconId: '#invalid', // svg id
          iconWH: 130,
          color: '#1B2733',
          reason: '该链接未生效', // 提示内容
          description: this.$t('请联系链接创建者了解具体情况'),
        },
        invalidLose: { // 链接已失效
          iconId: '#invalid', // svg id
          iconWH: 130,
          color: '#1B2733',
          pright: '29px', // 调整图视觉上偏差
          reason: '链接已失效', // 提示内容
          description: `${this.$t('该链接已被取消或超过有效期')}<br/>${this.$t('您可以联系链接发送者')}`,
        },
        invalidAccess: { // 链接无权限
          iconId: '#noPower', // svg id
          iconWH: 130,
          color: '#1B2733',
          reason: '暂无权限', // 提示内容
          description: this.$t('当前用户无权查看该分享，请联系分享人'),
        },
        invalidPreview: { // 外链文件无权限预览
          iconId: `#${this.getFileIcon()}`,
          iconWH: 70,
          color: '#282E3D',
          title: `${this.getTitle()}`,
          size: `${this.data.size || '--'}`, // 文件大小
          marginTop: 21, // 下载按钮margin-top
          iconMarginTop: 182, // 图标距顶部
          fontSize: 16, // title的字体大小
          isVirus: this.data.isvirus, // //是否病毒文件
          link: true, // 控制二维码是否出现
          reason: this.$t('抱歉，您没有权限预览该文件，您可选择下载到本地或转存至网盘'),
          btnText: [{
            val: this.checkLinkPermission() ? '下载' : '',
            key: 'download',
          }],
        },
        invalidDemo: {
          iconId: '#tiyan',
          iconWH: 130,
          iconMarginTop: 157, // 图标距顶部
          reason: '体验版不支持预览，请升级版本',
          color: '#1B2733',
          copyright: this.$t('北京联想协同科技有限公司 版权所有 京ICP备11035381'),
        },
        invalidPwd: {
          iconId: '#loadFail',
          iconWH: 130,
          reason: '密码错误',
          description: `${this.$t('该链接密码已失效')}<br/>${this.$t('请重新输入密码')}`,
          btnText: [{
            val: '重新输入',
            key: 'reinput',
          }],
        },
      },
    }
  },
  computed: {
    /**
         * 判断是不是文件夹外链里的文件预览
         */
    isPreviewInLinkFolder() {
      const route = this.$route.name === 'linkfile'
      return route
    },
  },
  mounted() {
    this.setPosition()
    window.addEventListener('resize', this.setPosition)
  },
  destroyed() {
    window.removeEventListener('resize', this.setPosition)
  },
  methods: {
    /**
         * 获取文件后缀名
         */
    getExt() {
      if (this.data && this.data.mime_type) {
        return this.data.mime_type.split('/')[1]
      }
      return ''
    },
    /**
         * qrcode
         */
    getCreateCode() {
      // 重构外链的url为/v/link/view, 旧外链的url为/link/view,由于未重构H5外链，所以访问H5外链需要修改url成/link/view
      const fullPath = window.location.origin + this.$route.fullPath
      return `${window.location.origin}/v2/image/qrcode?t=${fullPath}&d=100`
    },
    /**
        * 定位
        */
    setPosition() {
      const contentWidth = this.$refs.abnormalContainer.offsetWidth // 获取宽度
      const contentHeight = this.$refs.content.offsetHeight

      this.$refs.content.style.width = `${contentWidth}px`
      this.$refs.content.style.height = `${contentHeight}px`
      this.left = -contentWidth / 2 // 设置居中
      this.top = -contentHeight / 2 // 设置居中
    },
    /**
        * 按钮点击事件
        */
    abnormal(key) {
      this.$emit('abnormal', key)
    },
    /**
         * 获取文件类型
         */
    getFileIcon() {
      const { data } = this
      if (data && data.mime_type) {
        return typeIcon(data.mime_type.split('.').pop())
      }
      return 'other'
    },
    checkLinkPermission() {
      const { data } = this
      const power = resolveFileAction(data.access_mode)
      // 含有下载权限，并且该文件不是apk类型的文件
      if (/download/.test(power) && !/\.apk$/.test(data.mime_type)) {
        return true
      }
      return false
    },
    /**
         * 有无下载权限
         */
    checkPermission() {
      const { data } = this
      if (data && data.access_mode) {
        return isHasAuth(data.access_mode, 'download')
      }
      return false
    },
    /**
         * 获取文件的title
         */
    getTitle() {
      const { data } = this
      let path = ''
      let len = 1
      if (data && data.path) {
        path = data.path.split('/')
        len = path.length
      }
      return path[len - 1] || ''
    },
  },
}
</script>
<style lang="less" scoped>
@import '~less/button.less';
.copyright{
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #929CA9;
  margin-top: 188px;
  div{
    text-align: center;
  }
}
.ab-qrwrapper{
  margin-top: 90px;
  text-align: center;
}
.qr-wrapper{
  box-sizing: border-box;
  height: 124px;
  border: 1px solid #E8EBEF;
  border-radius: 2px;
  width: 340px;
  left: 0;
  right: 0;
  margin: auto;
  padding: 12px;
  img{
    box-sizing: border-box;
    width: 100px;
    height: 100px;
    float: left;
    margin-right: 12px;
  }
  .right{
    width: 202px;
    height: 100px;
    float: left;
    box-sizing: border-box;
    font-size: 14px;
    color: #67707C;
    letter-spacing: 0;
    font-family: PingFangSC-Regular;
    position: relative;
    span{
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      margin: auto;
      transform: translateY(-50%);
    }
  }
}
.ab-wrapper{
  width:100%;
  height:100%;
}

.back{
  position: relative;
  height: 100%;
  width: 100%;
  background-color: white;
}
.file-size{
  margin-left:12px;
  font-size: 14px;
  color: #637282;
  letter-spacing: 0;
}
.file-name{
  font-size: 14px;
  color: #637282;
  letter-spacing: 0;
}
.file-info{
  margin-top: 12px;
  text-align: center;
}
.ab-content{
  position: absolute;
  top: 50%;
  left: 50%;
  box-sizing: border-box;
  padding: 0 20px;
}
.ab-img{
  margin: 0 auto;
  display: block;
}
.ab-svg{
  height: 130px;
  width:130px;
}
.ab-title{
  display: block;
  font-size: 14px;
  color: #637282;
  letter-spacing: 0;
  line-height: 20px;
  //color: #282E3D;//外链
  .virus {
    font-size: 12px;
    color: #FF5554;
    border: 1px solid #FF5554;
    border-radius: 2px;
    padding: 0 2px;
    margin-left: 8px;
    vertical-align: text-bottom;
  }
}
.ab-size{
  display: block;
  font-size: 14px;
  letter-spacing: 0;
  color: #67707C;
  margin-top: 4px;
  // padding-bottom: 21px;
}
.ab-reason{
  display: block;
  text-align: center;
  margin: 12px 0;
  font-size: 14px;
  color: #282E3D;
  line-height: 20px;
  letter-spacing: 0;
  // color: #1B2733;//外链
}
.ab-description{
  font-size: 14px;
  color: #637282;
  letter-spacing: 0;
  line-height: 20px;
}
.ab-icon-wrapper{
  text-align: center;
}
.ab-tip-wrapper{
  text-align: center;
  margin: 12px auto 0;
}
.ab-btn-wrapper{
  text-align: center;
  margin: 24px auto 0;
}
.link-download{
  width: 88px;
  height: 32px;
  background: #0a64fa;
  border: none;
  border-radius: 2px;
  cursor: pointer;
  color: #fff;
  &:hover{
    background: #3b83fb;
  }
}
.lv-bn:last-child{
  margin-right: 0px;
}
.lv-bn:nth-child(even){
  color: #fff;
  background: #0a64fa;
  border-color: #0a64fa;
  &:hover{
    background: #3b83fb;
    border-color: #3b83fb;
  }
  &:active{
    background: #095ae1;
    border-color: #095ae1;
  }
}
</style>
